import Constants from './constants';
import CryptoJS from 'crypto-js';
import Global from './global';
import Comm from './comm';
import MediaSql from './media-sql';
import { Message, MessageBox } from 'kfront-baseui';
let util = {};
util.getChromeExtVersion = function() {
  let chromeExt = document.getElementById('chromeExt');
  if(!chromeExt) return '';
  return chromeExt.getAttribute('version') || '';
};
util.getSidebarStatus = function(){
    let result = localStorage.getItem(Constants.STORAGE_KEY_SIDEBAR_STATUS);
    if(result){
        return parseInt(result);
    }else{
        return 0;
    }
};
util.setSidebarStatus = function(sidebarStatus){
    return localStorage.setItem(Constants.STORAGE_KEY_SIDEBAR_STATUS, sidebarStatus);
};
util.isWindowMap = function () {
    return location.href.indexOf('#/map') >= 0 || location.href.indexOf('#/welcome/map') >= 0;
};

util.isOpenedWindow = function () {
    if ((window.menubar && !window.menubar.visible) || (this.isIE() && window.name && window.name.length > 0)) { //window open 弹出框
        return true;
    }else{
        let isChromeExtensionWindow = this.isChromeExtensionWindow();
        if (isChromeExtensionWindow) { //插件弹出框
            return true;
        } else {
            return false;
        }
    }
};

util.getAppId = function(appId){
  if(!appId){
    if(Global.getAppPortalId()){
      return Global.getAppPortalId();
    } else {
      appId = Global.getAppName();
    }
  }
  let hostUrl = this.getHost();
  let suffix = hostUrl.substring(location.protocol.length, hostUrl.length);
  suffix = suffix.replace(/\//g, '').replace(/\./g, '').replace(/:/g, '');
  let result = appId + '_' + suffix;
  return result;
};

util.openWindows = function(windows, isPopup = true){
    var appId = Global.getAppName();
    if(this.isInstalledChromeExtension() && isPopup){
        let windowArray = [];
        windows.forEach(win => {
            let url = '';
            if(win.windowId === Constants.WIN_LOGIN){
                appId = Constants.WIN_LOGIN;
            }
             url = this.getFullUrl(win.url);
            if(url.indexOf('?') > 0){
              url = url + '&chromeExtWin=Y&windowId=' + win.windowId;
            } else {
              url = url + '?chromeExtWin=Y&windowId=' + win.windowId;
            }
            let mWin = {
                windowId: win.windowId,
                windowState: {state: 'fullscreen'},
                isPrimary: win.primary,
                params: {
                    url: url,
                    left: 0,
                    top: 0,
                    type: 'popup'
                }
            };
            if(Global.isSubWindow() || url.indexOf('subwindow=Y') >=0){
              mWin.isSubWindow = true;
            }
            if(!this.isNull(win.screenIndex)){
              mWin.screenIndex = win.screenIndex;
            }
            windowArray.push(mWin);
        });
        let winParams = {
            action: Constants.CRX_EVENT_OPEN_WINDOWS,
            appId: this.getAppId(appId),
            windowArray: windowArray
        };
        console.log('winParams>>>', winParams);
        let event = document.createEvent('CustomEvent');
        event.initCustomEvent(Constants.CRX_EVENT_OPEN_WINDOWS, false, false, winParams);
        document.dispatchEvent(event);
    }else{
        windows.forEach(win => {
            this.openWindow(win.windowId, win.url);
        });
    }
};
util.moveScreen = function(toLeft){
  let windows = Global.getWindows();
  let windowId = Global.getSessionWindowId();
  let index = 0;
  for (let i = 0; i < windows.length; i++) {
    if (windows[i].windowId === windowId) {
      index = i;
      break;
    }
  }
  let nextIndex = -1;
  if (toLeft) {
    if(index > 0){
      nextIndex = index - 1;
    }else{
      nextIndex = windows.length - 1;
    }
  } else {
    if(index < windows.length - 1){
      nextIndex = index + 1;
    }else{
      nextIndex = 0;
    }
  }
  if(nextIndex >= 0){
    let nextScreenIndex = windows[nextIndex].screenIndex;
    let nextPrimary = windows[nextIndex].primary;
    let screenIndex = windows[index].screenIndex;
    let primary = windows[index].primary;
    if (primary) {
      delete windows[index].primary;
      windows[nextIndex].primary = primary;
    }
    if (screenIndex) {
      delete windows[index].screenIndex;
      windows[nextIndex].primary = screenIndex;
    }
    if (nextPrimary) {
      delete windows[nextIndex].primary;
      windows[index].primary = nextPrimary;
    }
    if (nextScreenIndex) {
      delete windows[nextIndex].screenIndex;
      windows[index].screenIndex = nextScreenIndex;
    }
    let tempWin = util.clone(windows[index]);
    windows[index] = windows[nextIndex];
    windows[nextIndex] = tempWin;

    Global.setWindows(windows);
    console.log('switchScreen>>>', windows);
    util.swtichScreen(windows);
    // console.log('splitScreen>>>', windows);
    // util.splitScreen(windows);
  }
};
util.swtichScreen = function(windows){ //多屏时分配和切换屏幕
  var appId = Global.getAppPortalId() || this.getAppId(Global.getAppName());
  if(this.isInstalledChromeExtension()){
    let windowArray = [];
    windows.forEach(win => {
      let window = {
        windowId: win.windowId,
        isPrimary: win.primary
      };
      if(!this.isNull(win.screenIndex)){
        window.screenIndex = win.screenIndex;
      }
      windowArray.push(window);
    });
    let winParams = {
      action: Constants.CRX_EVENT_SWITCH_SCREEN,
      appId: appId,
      windowArray: windowArray
    };
    console.log('winParams>>>', winParams);
    let event = document.createEvent('CustomEvent');
    event.initCustomEvent(Constants.CRX_EVENT_SWITCH_SCREEN, false, false, winParams);
    document.dispatchEvent(event);
  }
};
util.splitScreen = function(windows) {
  var appId = Global.getAppPortalId() || this.getAppId(Global.getAppName());
  let primaryWindowId = (windows.find(x => x.primary) || {}).windowId;
  let winParams = {
    action: Constants.CRX_EVENT_SPLIT_SCREEN,
    appId: appId,
    primaryWindowId
  };
  let event = document.createEvent('CustomEvent');
  event.initCustomEvent(Constants.CRX_EVENT_SPLIT_SCREEN, false, false, winParams);
  document.dispatchEvent(event);
};
util.switchWindow = function(windowId, toBusiness = false, appId, outside = false){ // outside在登录页和门户会为true
  console.log('switchWindow>>>', window);
  if(!appId){
    appId = this.getAppId();
  }
  let swtichByChromeExt = outside ? this.isInstalledChromeExtension() : this.isChromeExtensionWindow(); //通过插件切换
  if(!windowId){
    let windows = Global.getWindows();
    if(windows.length == 2){
      for(let i = 0; i < windows.length; i++){
        let win = windows[i];
        if(toBusiness && (win.type === 'business' || (!win.type && i == 0))){
          windowId = win.windowId;
          break;
        } else if(!toBusiness && (win.type === 'map' || (!win.type && i == 1))){
          windowId = win.windowId;
          break;
        }
      }
    } else if(windows.length == 1){
      windowId = windows[0].windowId;
    }
  }
  if(swtichByChromeExt && windowId){ // 不可以用isChromeExtensionWindow替换，因为要考虑门户里以及登录页preloadMode下的swtichwindow
    let winParams = {
      action: Constants.CRX_EVENT_SWITCH_WINDOWS,
      appId: appId,
      windowId: windowId
    };
    let event = document.createEvent('CustomEvent');
    event.initCustomEvent(Constants.CRX_EVENT_SWITCH_WINDOWS, false, false, winParams);
    document.dispatchEvent(event);
  }else if(windowId){
    this.openWindow(windowId);
  }
};

util.openWindow = function (windowId, windowUrl) {
    let mixW = window.screen.availWidth;
    let mixH = window.screen.availHeight - 50;

    if (windowId === Constants.WIN_LOGIN) {
      let url = Constants.HOME_PAGE_LOGIN;
      if(windowUrl){
        url = windowUrl;
      }
        let app = window.open(this.getFullUrl(url), Constants.WIN_LOGIN, `width=${mixW}px, height=${mixH}px, top=0, left=0`);
        window[windowId] = app;
    }else {
        let windows = Global.getWindows();
        for (let i = 0; i < windows.length; i++) {
            if (windows[i].windowId == windowId) {
                if(Global.isPopUp()){
                  let app = window.open(this.getFullUrl(windows[i].url), windows[i].windowId, `width=${mixW}px, height=${mixH}px, top=0, left=0`);
                  app.focus();
                  window[windowId] = app;
                } else {
                  let app = window.open(this.getFullUrl(windows[i].url), windows[i].windowId);
                  app.focus();
                  window[windowId] = app;
                }
            }
        }
    }
};

util.openSubWindow = function (win, isPopUp = true) {
    if (win.url && win.url.indexOf('/') === 0 && win.url.indexOf('#') < 0) {
      win.url = '/#' + win.url;
    }
    Global.addSubWindow(win);
    if(isPopUp){
      var appId = Global.getAppName();
      if(this.isInstalledChromeExtension()){
        let windowArray = [];
        let url = '';
        if(win.windowId === Constants.WIN_LOGIN){
          appId = Constants.WIN_LOGIN;
        }
        url = this.getFullUrl(win.url);
        if(url.indexOf('?') > 0){
          url = url + '&chromeExtWin=Y&windowId=' + win.windowId;
        } else {
          url = url + '?chromeExtWin=Y&windowId=' + win.windowId;
        }
        let window = {
          windowId: win.windowId,
          windowState: {state: 'fullscreen'},
          isPrimary: win.primary,
          isSubWindow: true,
          params: {
            url: url,
            left: 0,
            top: 0,
            type: 'popup'
          }
        };
        if(win.screenIndex){
          window.screenIndex = win.screenIndex;
        }
        windowArray.push(window);
        let winParams = {
          action: Constants.CRX_EVENT_OPEN_WINDOWS,
          appId: this.getAppId(appId),
          windowArray: windowArray
        };
        console.log('winParams>>>', winParams);
        let event = document.createEvent('CustomEvent');
        event.initCustomEvent(Constants.CRX_EVENT_OPEN_WINDOWS, false, false, winParams);
        document.dispatchEvent(event);
      }else{
        let mixW = window.screen.availWidth;
        let mixH = window.screen.availHeight - 50;
        let url = this.getFullUrl(win.url);
        window.open(url, win.windowId, `width=${mixW}px, height=${mixH}px, top=0, left=0`);
      }
    } else {
      let url = this.getFullUrl(win.url);
      window.open(url);
    }
};

util.isWindowClosed = function (callback, messageBody = {}) {
    let result = false;
    setTimeout(() => {
        if(this.isIE() || messageBody.exit){
          result = true;
        } else {
          console.log('window>>>', window);
          console.log('window.opener>>>', window.opener);
          let windows = Global.getWindows();
          windows.forEach(win => {
            console.log(`window[${win.windowId}]>>>>`, window[win.windowId]);
            if(window[win.windowId] && window[win.windowId].closed){
              result = true;
            }
          });
          //非popup模式下，如果父窗口关闭（!window.opener）或者退出登录（!window.opener.sessionStorage.getItem(Constants.STORAGE_KEY_JWT_TOKEN))的话，则关闭当前打开的tab页
          if(!Global.isPopUp() && (Global.isSubWindow() || Global.getWindows().length >= 2)){
            if(!window.opener) {
              result = true;
            } else {
              // 此处 Constants.STORAGE_KEY_JWT_TOKEN 只会取本站前缀 门户跳转的需要模糊找一下jwt
              const jwtKey = Object.keys(window.opener.sessionStorage).find(x => x.indexOf('_STORAGE_KEY_JWT_TOKEN') > -1);
              if(!jwtKey || !window.opener.sessionStorage[jwtKey]) {
                result = true;
              }
            }
          }
        }
        callback(result);
    }, 1000);
};
util.getTheme = function(){
    let theme = sessionStorage.getItem(Constants.STORAGE_KEY_THEME) || localStorage.getItem(Constants.STORAGE_KEY_THEME);
    if(!theme){
        theme = Constants.THEME_DEFAULT;
      if(Global.getCustomConfig()['DEFAULT_THEME']){
        theme = Global.getCustomConfig()['DEFAULT_THEME'];
      }
    }
    return theme;
};

util.setTheme = function(type, forceUpdate = false, cache = true){ //个人中心点击换肤时，启动强制换肤
  if(cache){
    localStorage.setItem(Constants.STORAGE_KEY_THEME, type);
  }
  let _theme = '';
  if(Global.getCustomConfig()['THEME']){
    _theme = Global.getCustomConfig()['THEME'] + '_';
  }
  console.log('setTheme>>>>', type);
  if(Global.getEnv() === 'development' && !forceUpdate){ // 开发环境下可用
    //import('static/theme/' + type + '/' + _theme + 'index.scss');
    // require('static/theme/' + type + '/' + _theme + 'index.scss');
    Comm.importScss(type, _theme);
  }else{
    let defaultTheme = Constants.THEME_DEFAULT;
    if(Global.getCustomConfig()['DEFAULT_THEME']){
      defaultTheme = Global.getCustomConfig()['DEFAULT_THEME'];
    }
    if(!forceUpdate && type == defaultTheme){ // 第一次初始化时不需要换肤
      return;
    }
    let styleid = 'kiaf-theme-type';
    let styleTag = document.getElementById(styleid);
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.setAttribute('id', styleid);
      document.head.appendChild(styleTag);
    }
    try {
      let req = new XMLHttpRequest();
        req.open('GET', './static/theme/' + type + '/' + _theme + 'index.css?v=' + new Date().getTime(), true);
      req.onreadystatechange = () => {
        if (req.readyState === 4 && req.status === 200) {
          // console.error('XMLHttpRequest req.response>>>', req.response);
          let result = req.response;
          result = result.replace(/(\.\.\/)+submodule\//g, `${Comm.getHost()}/submodule/`);
          result = result.replace(/(\.\.\/)+main\//g, `${Comm.getHost()}/main/`);
          result = result.replace(/(\.\.\/)+static\//g, `${Comm.getHost()}/static/`);
          styleTag.innerText = result;
          if(document.getElementById('kiaf-theme-default')){
            document.getElementById('kiaf-theme-default').remove();
          }
        }
      };
      req.send();
    }catch (e) {
      console.error('fetch error>>>', e);
    }
  }
};

util.changeTheme = function(type, cache = false){
    util.setTheme(type, true, cache);
};

util.isInstalledChromeExtension = function(){
    let obj = document.getElementById('chromeExt');
    if (typeof obj != 'undefined' && obj != null) {
        return true;
    } else {
        return false;
    }
};

util.isChromeExtensionWindow = function(){
  return Global.isChromeExtWin();
};

util.addScript = function (url, callback) {
    var script = document.createElement('script');     // 创建script标签;
    script.type = 'text/javascript';                   // 设置type属性;
    script.src = url;                                  // 引入url;
    document.getElementsByTagName('head')[0].appendChild(script);    // 将script引入<head>中;
    script.onload = function(){
        if(callback){
            callback();
        }
    };
};

util.errorMessage = function (message, config, error) {
    Message({
        showClose: true,
        message: message,
        type: 'error'
    });
};

// 访问未授权页面时显示的信息
util.pagePermissionMessage = function () {
  Message({
    showClose: true,
    message: '您没有权限访问该页面',
    type: 'warning'
  });
}

util.encrypt = function (value, key) {
    return CryptoJS.AES.encrypt(value, key ||Global.getSecretKey()).toString();
};

util.decrypt = function (value, key) {
  let result = '';
  if(value){
    try {
      result = CryptoJS.AES.decrypt(value, key || Global.getSecretKey()).toString(CryptoJS.enc.Utf8);
    }catch (e) {
      result = '';
    }
  }
  return result;
};

util.MD5 = function(value){
  return  CryptoJS.MD5(value).toString();
};

util.closeCurrentTab = function(){
    if(this.isInstalledChromeExtension()){
        let winParams = {
            action: Constants.CRX_EVENT_CLOSE_TAB,
            appId: this.getAppId()
        };
        console.log('winParams>>>', winParams);
        let event = document.createEvent('CustomEvent');
        event.initCustomEvent(Constants.CRX_EVENT_CLOSE_TAB, false, false, winParams);
        document.dispatchEvent(event);
    }
};

util.clone = function (value) {
  try {
    return JSON.parse(JSON.stringify(value));
  }catch (e) {

  }
};
util.requestChromeExtScreens = function(){
  if(this.isInstalledChromeExtension()){
    let winParams = {
      action: Constants.CRX_EVENT_GET_SCREENS
    };
    console.log('winParams>>>', winParams);
    let event = document.createEvent('CustomEvent');
    event.initCustomEvent(Constants.CRX_EVENT_GET_SCREENS, false, false, winParams);
    document.dispatchEvent(event);
  }
};
util.newMediaSql = function (value) {
  try {
    return new MediaSql();
  }catch (e) {

  }
};

util.isCrossDomain = function (url) { //用于判断是否跨域
  let currDomain = this.getLocationDomain();
  if(url && url.indexOf(currDomain) == 0){
    return false;//域名相同，没有跨域
  } else {
    return true;
  }
};

util.closeAllWindow = function (loginMode = false) {
  if(this.isInstalledChromeExtension() && this.isChromeExtensionWindow()){
    if(loginMode){
      let winParams = {
        action: 'closeWindow',
        appId: this.getAppId(Constants.WIN_LOGIN),
        closeWindowId: Constants.WIN_LOGIN
      };
      console.log('winParams>>>>', winParams);
      let event = document.createEvent('CustomEvent');
      event.initCustomEvent('closeWindow', false, false, winParams);
      document.dispatchEvent(event);
    } else {
      let windows = Global.getWindows();
      for(let i = 0; i < windows.length; i++){
        let winParams = {
          action: 'closeWindow',
          appId: this.getAppId(),
          closeWindowId: windows[i].windowId
        };
        console.log('winParams>>>>', winParams);
        let event = document.createEvent('CustomEvent');
        event.initCustomEvent('closeWindow', false, false, winParams);
        document.dispatchEvent(event);
      }
    }
  } else {
    window.close();
    window.location.href = 'about:blank';
  }
};

/**
 * @description: 功能 支持自定义打开URL 支持打开tab/window 支持window全屏
 * @param {sring|Array} url [必须] 要打开的链接地址 要在窗口中打开的一个 URL 或 URL 数组。完整的 URL必须包含协议。默认为“打开新的标签页”页面。
 * @param {object} option [可选] 配置项
 * @param {string} option.type             默认 "tab" 标签页 "tab" 窗口 "window"
 * @param {boolean} option.active          默认 true 是否激活打开的tab/窗口
 * @param {boolean} option.tabIndex        [type=tab] 标签页在窗口中的位置，提供的值如果超过0与窗口中标签页数目之间的范围，将会自动限定在这一范围。
 * @param {boolean} option.tabPinned       [type=tab] 标签页是否应该固定，默认为 false。
 * @param {Number} option.openerTabId      [type=tab] 打开这一标签页的标签页标识符，传0匹配当前，默认不设置。
 * @param {Number} option.windowId         [type=tab] 创建新标签页的窗口，默认为当前窗口。
 * @param {string} option.windowType       [type=window] 默认 "normal" 支持 "normal", "popup", "panel"
 * @param {boolean} option.windowIncognito [type=window] 默认 false 新窗口是否为隐身窗口
 * @param {boolean} option.fullscreen      [type=window] 默认 false 新窗口是否全屏
 * @param {Object} option.bounds           [type=window] 窗口位置及大小
 * @param {Number} option.bounds.left      [type=window] 新窗口与屏幕左侧的距离，以像素为单位 (screenIndex设置时，此项失效)
 * @param {Number} option.bounds.top       [type=window] 新窗口与屏幕顶部的距离，以像素为单位 (screenIndex设置时，此项失效)
 * @param {Number} option.bounds.width     [type=window] 新窗口的宽度（包含边框），以像素为单位，默认为自然宽度。
 * @param {Number} option.bounds.height    [type=window] 新窗口的高度（包含边框），以像素为单位，默认为自然高度。
 * @param {Number} option.screenIndex      [type=window] 新窗口的高度在第几个屏幕打开 0-主屏。不在数量范围内会在主屏打开
 * @return: none
 */
util.openLink = function (url, option) {
  var appId = Global.getAppPortalId() || this.getAppId(Global.getAppName());
  let winParams = {
    action: Constants.CRX_EVENT_OPEN_LINK,
    appId: appId,
    url,
    option
  };
  let event = document.createEvent('CustomEvent');
  event.initCustomEvent(Constants.CRX_EVENT_OPEN_LINK, false, false, winParams);
  document.dispatchEvent(event);
};
util.downloadFile = function (url, config = {}, callbackFun) {
  let options = {
    method: 'GET'
  };
  if(config.headers){
    options.headers = config.headers;
  }
  if(config.method){
    options.method = config.method;
  }
  if(config.body){
    options.body = JSON.stringify(config.body);
  }
  let fileType = 'image/png';
  let fileName = '';
  let fileSuffix = '';
  if(url && url.toLowerCase().indexOf('.mp4') > 0) {
    fileType = 'video/mp4';
    fileSuffix = '.mp4';
  } else if(url && url.toLowerCase().indexOf('.zip') > 0) {
    fileType = 'application/x-zip-compressed';
    fileSuffix = '.zip';
  } else if(url && (url.toLowerCase().indexOf('.xls') > 0 || url.toLowerCase().indexOf('.xlsx') > 0)) {
    fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    fileSuffix = url.toLowerCase().indexOf('.xlsx') > 0 ? '.xlsx' : 'xls';
  } else if(url && (url.toLowerCase().indexOf('.pdf') > 0)) {
    fileType = 'application/pdf';
    fileSuffix = '.pdf';
  }	else if(url && (url.toLowerCase().indexOf('.docx') > 0)) {
    fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    fileSuffix = '.docx';
  } else if(url && (url.toLowerCase().indexOf('.doc') > 0)) {
    fileType = 'application/msword';
    fileSuffix = '.doc';
  } else if(url && (url.toLowerCase().indexOf('.txt') > 0)) {
    fileType = 'text/plain';
    fileSuffix = '.txt';
  } else if(url && (url.toLowerCase().indexOf('.png') > 0 || url.toLowerCase().indexOf('.jpg') > 0 || url.toLowerCase().indexOf('.jpeg') > 0)) {
    fileType = 'image/png';
    fileSuffix = '.png';
    if(url.toLowerCase().indexOf('.jpeg') > 0){
      fileSuffix = '.jpeg';
    } else if(url.toLowerCase().indexOf('.jpg') > 0){
      fileSuffix = '.jpg';
    }
    let watermarkTxt = Global.getWatermarkTxt();
    if(Global.getCustomConfig()['KIAF_WATERMARK_IMAGE'] && watermarkTxt && url.indexOf('/waterMark/add') < 0){ // KIAF_WATERMARK_IMAGE 配置用于避免后台没有同步升级waterMark/add接口，导致出错
      let imageAddr = url;
      let suffix = imageAddr.substring(imageAddr.lastIndexOf('.') + 1);
      let legalSufffixList = ['jpeg', 'jpg', 'png'];
      if(legalSufffixList.indexOf(suffix.toLowerCase()) < 0){
        suffix = 'png';
      }
      url = Global.getBaseUrl() + '/waterMark/add?value=' + encodeURIComponent(watermarkTxt) + '&suffix=' + suffix.toLowerCase() + '&imageAddr=' + imageAddr;
      if(Global.getCustomConfig()['KIAF_WATERMARK_IMAGE'] == 'POST'){
        options.method = 'POST';
        config.body = {
          value: watermarkTxt,
          suffix: suffix.toLowerCase(),
          imageAddr: imageAddr
        }
        options.headers = {
          'Content-Type': 'application/json',
          'jwt-token': Global.getJwtToken()
        }
        options.body = JSON.stringify(config.body);
        url = Global.getBaseUrl() + '/waterMark/add';
        // url = 'http://192.168.8.93:8095/waterMark/add';
      }
    }
  }
  if(config.fileName){
    fileName = config.fileName;
  } else if(fileSuffix){
    let subUrl = url.substring(0,url.toLowerCase().indexOf(fileSuffix) + fileSuffix.length)
    let arr = subUrl.split('/');
    fileName = arr[arr.length - 1];
  } else {
    fileName = new Date().getTime() + '.png';
  }
  let proxyFlag = false;
  if((Global.getCustomConfig()['KIAF_PROXY_HOST_LIST']|| Global.getCustomConfig()['KIAF_NOPROXY_HOST_LIST']) && url && url.indexOf('/waterMark/add') < 0){
    if(Global.getCustomConfig()['KIAF_PROXY_HOST_LIST']){
      proxyFlag = Global.getCustomConfig()['KIAF_PROXY_HOST_LIST'].find((host) => {return url.toLowerCase().indexOf(host) >= 0 && url.toLowerCase().indexOf(host) <= 10}) ? true : false;//避免host在url的参数里面，通过0~10来控制
    } else if(Global.getCustomConfig()['KIAF_NOPROXY_HOST_LIST']){
      proxyFlag = Global.getCustomConfig()['KIAF_NOPROXY_HOST_LIST'].find((host) => {return url.toLowerCase().indexOf(host) >= 0 && url.toLowerCase().indexOf(host) <= 10}) ? false : true;//避免host在url的参数里面，通过0~10来控制
    }
    if(proxyFlag){
      let targetUrl = url;
      if(this.isChinese(targetUrl)){ //包含中文时encode处理一下
        targetUrl = encodeURI(targetUrl);
      }
      url = Global.getBaseUrl() + '/proxy';
      // url = 'http://192.168.8.238:8080/proxy'
      options.headers = {
        'jwt-token':Global.getJwtToken(),
        'target-url': targetUrl
      };
    }
  }
  if(config.fileType){
    fileType = config.fileType;
  }
  try {
    if(!proxyFlag && fileSuffix && Global.getCustomConfig()['KIAF_LINK_DOWNLOAD_LIST'] && Global.getCustomConfig()['KIAF_LINK_DOWNLOAD_LIST'].indexOf(fileSuffix) >= 0){ // 对于不用跨越的大文件采用浏览器直接下载
        setTimeout(() => {
          if(!config.id || !this.isCanceledDownloadFile(config.id)) {
            var link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
          }
        }, 3000);
    } else {
      fetch(url, options).then(
        response => {
          response.blob().then(blob => {
            if(!config.id || !this.isCanceledDownloadFile(config.id)) {
              var link = document.createElement('a');
              var file = new Blob([blob], { type: fileType });
              link.href = window.URL.createObjectURL(file);
              link.download = fileName;
              link.click();
              if(callbackFun) {
                callbackFun(true);
              }
            }
          });
        }
      ).catch((error) => {
        console.log('request failed', error);
        MessageBox.alert('请对下载资源进行授权！', '警告', {
          confirmButtonText: '确定',
          callback: action => {
            let a = document.createElement('a');
            a.href = url;
            a.target = '_blank';
            a.click();
          }
        });
        if(callbackFun) {
          callbackFun(false, error);
        }
      });
    }
  }catch (e) {
    console.error('fetch error' + url, e);
  }
};

util.getCanceledDownloadFiles = function () {
  let listStr = localStorage.getItem(Constants.STORAGE_KEY_CANCELED_DOWNLOAD_FILES);
  let list = [];
  if(listStr){
    try {
      list = JSON.parse(listStr);
    }catch (e) {
      list = [];
    }
  }
  return list;
};

util.cancelDownloadFile = function (id) {
  let list = this.getCanceledDownloadFiles();
  list.push(id);
  localStorage.setItem(Constants.STORAGE_KEY_CANCELED_DOWNLOAD_FILES, JSON.stringify(list));
};

util.isCanceledDownloadFile = function (id) {
  let list = this.getCanceledDownloadFiles();
  for(let i = list.length - 1; i >= 0; i--){
    let item = list[i];
  }
  return list.find((canceledId) => { return canceledId == id; });
};

util.getDownloadedFiles = function () {
  let downloadCompletedListStr = localStorage.getItem(Constants.STORAGE_KEY_DOWNLOAD_FILES);
  let downloadCompletedList = [];
  if(downloadCompletedListStr){
    try {
      downloadCompletedList = JSON.parse(downloadCompletedListStr);
    }catch (e) {
      downloadCompletedList = [];
    }
  }
  return downloadCompletedList;
};

util.isFileDownloadedBefore = function (downloadInfo) {
  let downloadCompletedList = this.getDownloadedFiles();
  for(let i = downloadCompletedList.length - 1; i >= 0; i--){
    let item = downloadCompletedList[i];
    if(item.expiredTime < new Date().getTime()) {
      downloadCompletedList.splice(i, 1);
    }
  }
  return downloadCompletedList.find((item) => { return item.taskId == downloadInfo.taskId; });
};

util.addDownloadedFiles = function (downloadInfo) {
  let downloadCompletedList = this.getDownloadedFiles();
  downloadCompletedList.push({taskId: downloadInfo.taskId, expiredTime: new Date().getTime() + 60 * 1000});// expired after 60s
  localStorage.setItem(Constants.STORAGE_KEY_DOWNLOAD_FILES, JSON.stringify(downloadCompletedList));
}

util.getSocketClient = function (url) {
  if(!this.socketClientMap){
    this.socketClientMap = {};
  }
  if(!url){
    url = `${Global.getBaseUrl()}/ws/stomp`;
  }
  if(!this.socketClientMap[url] || !this.socketClientMap[url + '-socket']){
    console.log('create socketClientMap>>>', this.socketClientMap);
    let socket = new window.SockJS(url);
    let stompClient = window.Stomp.over(socket);
    stompClient.debug = null;
    this.socketClientMap[url] = stompClient;
    this.socketClientMap[url + '-socket'] = socket;
  }
  return this.socketClientMap[url];
}
util.disconnectSocketClient = function (socketClient) {
  for(let key in this.socketClientMap){
    if(this.socketClientMap[key] == socketClient){
      socketClient.disconnect();
      if(this.socketClientMap[key + '-socket']){
        this.socketClientMap[key + '-socket'].close();
      }
      delete this.socketClientMap[key];
      delete this.socketClientMap[key + '-socket'];
    }
  }
}
for(let key in Comm){
  util[key] = Comm[key];
}
export default util;
